/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import AssetTableCell from './AssetTableCell'
import { formatDate12, joinStrings, timeSinceFormatted } from './utils'

import { AssetDoorMp } from '../types'

type DoorMpSummaryColProps = {
  doorMps: AssetDoorMp[]
}

const DoorMpSummaryCol: React.FC<DoorMpSummaryColProps> = ({ doorMps }) => {
  const tooltip = joinStrings(
    ...doorMps.map((d) => {
      let details = `${d.name}: ${d.connected}`
      if (d.tagOnline && d.tagSampleTime) {
        details += ` since ${formatDate12(d.tagSampleTime)}`
      } else {
        let offlineString = 'Offline'
        let offlineTimeAgo = ''
        if (d.onlineSampleTime) {
          offlineString += ` since ${formatDate12(d.onlineSampleTime)}`
          offlineTimeAgo = ` ${timeSinceFormatted(d.onlineSampleTime)}`
        }
        details += ` (${offlineString})${offlineTimeAgo}`
      }
      return details
    })
  )

  const content = doorMps.length === 0 ? <div className="h-4 w-full flex"></div> : <>Door MPs: {doorMps.length}</>
  return (
    <AssetTableCell tooltip={tooltip}>
      <div className="w-full h-full">{content}</div>
    </AssetTableCell>
  )
}

export default DoorMpSummaryCol
